import * as React from 'react';
import DataList from '../../components/controls/datagrid/DataList';
import DataColumn from '../../components/controls/datagrid/DataColumn';
import { BodyElements } from '../../components/controls/body/bodyElements';

type Props = {
    items: any,
    controller: string,
    modal?: React.ReactNode,
    modaltitle?: string,
    modalwidth?: string,
    state?: any
}

export default (props: Props) => {


    return (
        <>
            <DataList items={props.items} modaltitle={props.modaltitle} modalwidth={props.modalwidth} modalController={props.controller} modal={props.modal} state={props.state}>
                <DataColumn kid='columnE' name='' fieldName='delete' minWidth={10} maxWidth={10} type='delete' />
                <DataColumn kid='column1' name='Prestazione' fieldName='healthservice' minWidth={200} maxWidth={300} align='left' />
                <DataColumn kid='column2' name='Tariffa' fieldName='rate' minWidth={80} maxWidth={100} align='right' />
                {props?.state?.item?.values?.medicalSpecialtyTypeId?.value == '1' && <DataColumn kid='column3' name='Elementi Dentali' fieldName='dentalElement' minWidth={200} align='left' />}
                {props?.state?.item?.values?.medicalSpecialtyTypeId?.value == '2' && <DataColumn kid='column3' name='Elementi Anatomici' fieldName='anatomicalElement' minWidth={200} align='left' />}
                <DataColumn kid='column4' name='Data fine validità' fieldName='endDate' minWidth={100} maxWidth={120} align='center' />
                <DataColumn kid='columnF' name='' fieldName='edit' minWidth={10} maxWidth={10} type='edit' />
            </DataList>
        </>
    );
}
